export default __webpack_public_path__ + "static/media/ios-info-circle.0b0c351e.svg";